const SETTINGS_PATH = '/settings';

export const historyIndexFromState = (state: unknown): number =>
  state && typeof state === 'object' && 'idx' in state && typeof state.idx === 'number'
    ? state.idx
    : 0;

export const transactionsBackTarget = (historyIndex: number): number | typeof SETTINGS_PATH =>
  historyIndex > 0 ? -1 : SETTINGS_PATH;
